import './App.css';
import NavBar from './components/NavBar';
import Home from './components/Home';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contacts from './components/Contacts';
import { additionalSkills } from './additionalSkills';

function App() {
  return (
    <main>
      <NavBar />
      <Home />
      <Skills />
      <div style={{ textAlign: 'center' }}>
        <h1>Additional Skills</h1>
      </div>
      <div className="experience-wrapper">
        <div className="experience-content">
          {additionalSkills.map((obj) => (
            <a
              key={obj.id}
              style={{ color: 'white', textDecoration: 'none' }}
              target="_blank"
              href={obj.href}>
              <article className="experience-card">
                <div className="experience-round">
                  <img width={75} height={75} src={obj.image} alt="react" />
                </div>
                <span>{obj.title}</span>
              </article>
            </a>
          ))}
        </div>
      </div>
      <Projects />
      <Contacts />
    </main>
  );
}

export default App;
